import type { ICustomControlRequestReadProps } from '../../interfaces/customControlRequestReadProps';
import { FormParagraph } from '../../../../elements/common';
import { Component } from '../../../../elements/Component';
import { FormLabel } from '../../../../elements/forms/FormLabel';
import { HorizontalFormGroupRead } from '../../../../elements/forms/horizontalFormGroupRead/HorizontalFormGroupRead';
import { InputContainer } from '../../../../elements/forms/InputContainer';

export class TiecgV1RequestSummary extends Component<ICustomControlRequestReadProps, {}> {
    public render() {
        if (!this.props.request.customControlData || !this.props.request.customControlData.indicationOutcomeText) {
            return null;
        }

        return (
            <HorizontalFormGroupRead>
                <FormLabel>Indicatie</FormLabel>
                <InputContainer>
                    <FormParagraph>{this.props.request.customControlData.indicationOutcomeText}</FormParagraph>
                </InputContainer>
            </HorizontalFormGroupRead>
        );
    }
}
